import { render, staticRenderFns } from "./FriendsPage.vue?vue&type=template&id=bfbff850&scoped=true&"
import script from "./FriendsPage.vue?vue&type=script&lang=js&"
export * from "./FriendsPage.vue?vue&type=script&lang=js&"
import style0 from "./FriendsPage.vue?vue&type=style&index=0&id=bfbff850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbff850",
  null
  
)

export default component.exports